module.exports = __webpack_public_path__ + "static/media/technology-mobile.aa3af257.svg";